import styled from 'styled-components';
import { colors, fontFamily } from '../../../Utils/tokens';

export const PromptActions = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.15s ease;

  &:focus-within {
    opacity: 1;
  }
`;

/** "Chat AI / Chat / User Prompt" */
export const PromptContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  width: 100%;

  &:hover ${PromptActions} {
    opacity: 1;
  }
`;

export const Bubble = styled.div`
  max-width: 384px;
  padding: 8px 12px;
  border-radius: 12px 12px 4px 12px;
  background-color: ${colors.secondary};
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: ${colors.onSurface};
  white-space: pre-wrap;
  word-break: break-word;
`;
